export function getEnvironment() {
    const envMap = {
        'beta-meetings.trendrealty.ru': 'beta',
        localhost: 'dev',
        'meetings.trendrealty.ru': 'prod',
        'meetings.trendrealty.trend-stage.tech': 'stage',
        'meetings.trendrealty.trend-team-01.tech': 'team01',
        'meetings.trendrealty.trend-team-02.tech': 'team02',
        'meetings.trendrealty.trend-team-03.tech': 'team03',
        'meetings.trendrealty.trend-team-04.tech': 'team04',
        'meetings.trendrealty.trend-team-05.tech': 'team05',
    } as const;

    return envMap[window.location.hostname as keyof typeof envMap];
}
